import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import RouteChangeTracker from "./components/RouteChangeTracker";

import Cookies from "js-cookie";
import Signup from "./pages/SignIn";
import Login from "./pages/Login";
import ForgotPassword from "./pages/Login/forgotPasswrod";
import RecoveryAccount from "./pages/Login/recovery";
import SignupDetails from "./pages/SignIn/SignupDetails";
import VerifySignupOTP from "./pages/SignIn/SignupOtp";
import ProtectedLayout from "./ProtectedLayout";
import Dashboard from "./pages/Dashboard";
import MyDocuments from "./pages/pdfEditor";
import Documents from "./pages/Documents";
import PdfEditor from "./pages/pdfmapping";
import { companyProfile } from "./store/reducers/profileSlice";
import { dashboard } from "./store/reducers/pdfeditor/dashboardSlice";
import BulkEsign from "./pages/BulkEsign";
import Signers from "./pages/Signers";
import NewPasswrod from "./pages/Login/newPassword";
import MyProfile from "./pages/MyProfile";
import DisableNumberScroll from "./DisableNumberScroll";
import VisitorIdHandler from "./VisitorIdHandler";
import ChooseTemplate from "./components/Esign/chooseTemplate";
import Premium from "./pages/Premium";
import LazyPdfViewer from "./components/Documents/pdflazyview";
import APIIntegration from "./pages/APIIntegration";
import StampPapers from "./pages/StampPapers";
import Settings from "./pages/Settings";
import EmailTemplates from "./pages/Settings/EmailTemplates";
import Archive from "./pages/Archive";

// super admin imports
import Superdashboard from "./pages/Superadmin/Superdashboard";
import SuperadminLogin from "./pages/Superadmin/SuperadminLogin";

function App() {
  const dispatch = useDispatch();
  const { uploadedDocument } = useSelector((state) => state.uploadDocument);
  // The cookie is the session marker. Legacy localStorage tokens can outlive it.
  const [token, setToken] = useState(() => Cookies.get("token") || null);

  useEffect(() => {
    localStorage.removeItem("token");
    const checkToken = () => setToken(Cookies.get("token") || null);
    const interval = setInterval(checkToken, 1000);
    window.addEventListener("focus", checkToken);
    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", checkToken);
    };
  }, []);

  useEffect(() => {
    if (!token) return;
    dispatch(companyProfile());
    dispatch(dashboard());
  }, [token, dispatch]);

  return (
    <Router>
      <VisitorIdHandler />
      <RouteChangeTracker />
      <DisableNumberScroll />
      <Routes>
        <Route
          path="/signup"
          element={token ? <Navigate to="/esign/new-esign" replace /> : <Signup />}
        />
        <Route
          path="/verify-otp"
          element={
            token ? (
              <Navigate to="/esign/new-esign" replace />
            ) : localStorage.getItem("email") ? (
              <VerifySignupOTP />
            ) : (
              <Navigate to="/signup" />
            )
          }
        />
        <Route
          path="/sign-in-details"
          element={
            token ? (
              <Navigate to="/esign/new-esign" replace />
            ) : localStorage.getItem("email") ? (
              <SignupDetails />
            ) : (
              <Navigate to="/signup" />
            )
          }
        />
        <Route
          path="/login"
          element={token ? <Navigate to="/esign/new-esign" replace /> : <Login />}
        />
        <Route
          path="/forgot-password"
          element={token ? <Navigate to="/esign/new-esign" replace /> : <ForgotPassword />}
        />
        <Route
          path="/new-password"
          element={token ? <Navigate to="/esign/new-esign" replace /> : <NewPasswrod />}
        />
        <Route
          path="/recovery-account"
          element={token ? <Navigate to="/esign/new-esign" replace /> : <RecoveryAccount />}
        />

        {/* super admin routes */}
        <Route path="/superlogin" element={<SuperadminLogin />} />
        <Route path="/superdashboard" element={<Superdashboard />} />

        <Route element={<ProtectedLayout token={token} />}>
          <Route path="/dashboard" element={<Dashboard />} />
          {/* <Route path="/dashboard" element={<Premium type="dashboard" />} /> */}
          <Route path="/lazypdf" element={<LazyPdfViewer />} />
          <Route path="/esign/new-esign" element={<MyDocuments />} />
          <Route path="/esign/choose-template" element={<ChooseTemplate />} />
          <Route
            path="/esign/pdfeditor"
            element={
              uploadedDocument?.data?.document_id && uploadedDocument?.fullView ? (
                <PdfEditor />
              ) : (
                <Navigate to="/esign/new-esign" replace />
              )
            }
          />
          <Route path="/esign/documents" element={<Documents />} />
          <Route path="/esign/bulk-esign" element={<BulkEsign />} />
          <Route path="/esign/signers" element={<Signers />} />
          <Route path="/esign/archive" element={<Archive />} />
          <Route path="/esign/stamp-paper" element={<StampPapers />} />
          <Route path="/esign/trash" element={<Premium type="trash" />} />
          <Route path="/workflow" element={<Premium type="workflow" />} />
          {/* <Route path="/api-integration" element={<Premium type="api-integration" />} /> */}
          <Route path="/api-integration" element={<APIIntegration />} />
          <Route path="/our-products" element={<Premium type="our-products" />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/email-templates" element={<EmailTemplates />} />
          <Route path="/my-profile" element={<MyProfile ActiveTab={"my-profile"} />} />
          <Route
            path="/change-password"
            element={<MyProfile ActiveTab={"change-password"} />}
          />
          <Route path="/credits" element={<MyProfile ActiveTab={"credits"} />} />
          <Route
            path="/help-support"
            element={<MyProfile ActiveTab={"help-support"} />}
          />
        </Route>
        <Route
          path="*"
          element={<Navigate to={token ? "/esign/new-esign" : "/signup"} replace />}
        />
      </Routes>

      <ToastContainer
        position="bottom-right"
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        autoClose={3000}
      />
    </Router>
  );
}

export default App;
